import { cx } from '@twind/core';
import { ModuleItem } from 'app/services/helpCenter';

interface PillProps {
  pill: ModuleItem;
  onClick: () => void;
}

interface TailorSearchPillsProps {
  pills: ModuleItem[];
  onPillClick?: (pill: ModuleItem) => void;
  className?: string;
}

const Pill = ({ pill, onClick }: PillProps) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-3 py-2 bg-white rounded text-sm leading-none font-medium border border-pills-borderColor hover:border-pills-hoverBorderColor focus:border-pills-hoverBorderColor"
    >
      {pill.icon && (
        <img
          src={pill.icon}
          alt={`${pill.pill_text} icon`}
          className="w-[14px] h-[14px]"
        />
      )}
      <span>{pill.pill_text}</span>
    </button>
  );
};

export default function TailorSearchPills({ pills, onPillClick, className }: TailorSearchPillsProps) {
  const handlePillClick = (pill: ModuleItem) => {
    if (onPillClick) {
      onPillClick(pill);
    }
  };

  return (
    <div
      id="ostro-tailor-pills-container"
      className={cx('~(flex flex-wrap gap-3 py-4)', className)}
    >
      {pills.map((pill) => (
        <Pill
          key={pill.pill_text}
          pill={pill}
          onClick={() => handlePillClick(pill)}
        />
      ))}
    </div>
  );
}
